module.exports = __webpack_public_path__ + "img/10.156494e2.jpg";